import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Modal,
  Tab,
  Tabs,
} from "react-bootstrap";
import { Calender, DropDownUI, TextInputForm } from "../components/Forms";
import { PageHead } from "../components/PageTitle";
import { MdDeleteForever } from "react-icons/md";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { ClickButton, Delete } from "../components/Buttons";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import companyId from "../config/companyId";

const DOMAIN = "https://sivakasiogcrackers.com/api";

const alltax = [
  { value: "GST@0%", label: "GST@0%" },
  { value: "IGST@18%", label: "IGST@18%" },
  { value: "GST@18%", label: "GST@18%" },
];

const OnlineBillEntry = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};

  const [discountType, setDiscountType] = useState(
    rowData?.discount_type || "Discount %"
  );
  const [globalTax, setGlobalTax] = useState({
    tax_type: rowData?.gst_type ? rowData.gst_type.split("@")[0] : "GST",
    tax_percentage: rowData?.gst_type
      ? parseFloat(rowData.gst_type.match(/\d+\.*\d*/)?.[0] || 0)
      : 0,
    tax_label: rowData?.gst_type || "GST@0%",
  });

  const initialState =
    type === "edit"
      ? {
          ...rowData,
          discount: rowData.discount,
          discount_type: rowData.discount_type,
          discount_amount: rowData.discount_amount,
          sub_total: rowData.sub_total,
          discount_total: (
            parseFloat(rowData.sub_total || 0) -
            (rowData.discount_type === "Discount Amount"
              ? parseFloat(rowData.discount || 0)
              : (parseFloat(rowData.sub_total || 0) *
                  parseFloat(rowData.discount || 0)) /
                100) +
            parseFloat(rowData.gst_amount || 0)
          ).toFixed(2),
          products: rowData.products
            ? rowData.products.map((item) => ({
                product_id: item.id || item.product_id || "",
                product_name: item.product_name || "",
                qty: String(item.qty || 0),
                unit_id: item.unit_id || "",
                unit_name: item.unit_name || "",
                per_price: String(item.per_price || 0),
                discount: item.discount != null ? String(item.discount) : "0",
                discount_amt:
                  item.discount != null ? String(item.discount) : "0",
                total_price: String(item.total_price || 0),
              }))
            : [],
          bill_date:
            rowData.bill_date && moment(rowData.bill_date).isValid()
              ? moment(rowData.bill_date).format("YYYY-MM-DD")
              : moment().format("YYYY-MM-DD"),
        }
      : {
          customer_name: "",
          bill_date: moment().format("YYYY-MM-DD"),
          address: "",
          phone: "",
          tax_invoice_no: "",
          sub_total: "",
          discount_total: "",
          discount: "",
          discount_type: "Discount %",
          discount_amount: "",
          remark: "",
          products: [
            {
              product_id: "",
              product_name: "",
              qty: "",
              unit_id: "",
              unit_name: "",
              per_price: "",
              discount: "",
              discount_amt: "",
              total_price: "",
            },
          ],
        };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [productData, setProductData] = useState([]);
  const [UnitData, setUnitData] = useState([]);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await fetch(`${DOMAIN}/products.php?id=${companyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }

        const responseData = await response.json();
        setLoading(false);
        if (responseData.status === 200 && Array.isArray(responseData.data)) {
          const validData = responseData.data.filter(
            (item) => item && typeof item.product_name === "string"
          );
          setProductData(validData);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.message);
      }
    };

    const fetchUnitData = async () => {
      try {
        const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch units");
        }

        const responseData = await response.json();
        if (responseData.status === 200) {
          setUnitData(responseData.data);
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
        toast.error(error.message);
      }
    };

    fetchProductData();
    fetchUnitData();
  }, []);

  const setLabel = (value, field) => {
    if (!value || !moment(value).isValid()) {
      return;
    }
    setFormData({
      ...formData,
      [field]: moment(value).format("YYYY-MM-DD"),
    });
  };

  const handleSubmit = async () => {
    try {
      const subtotal = parseFloat(formData.sub_total) || 0;
      const discountValue = parseFloat(formData.discount) || 0;
      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discountValue) / 100).toFixed(2)
          : discountValue.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discountValue) / 100).toFixed(2)
          : (subtotal - discountValue).toFixed(2);
      const taxRate = parseFloat(globalTax.tax_percentage) || 0;
      const taxAmount = (discountedSubtotal * taxRate) / 100;

      const sanitizedFormData = {
        ...formData,
        discount_type: discountType,
        gst_type: globalTax.tax_label,
        gst_amount: taxAmount.toFixed(2),
        discount_amount: discountAmount,
        products: formData.products.map((product) => ({
          product_id: product.product_id,
          qty: product.qty,
          unit_id: product.unit_id,
          unit_name: product.unit_name,
          per_price: product.per_price,
          discount: product.discount,
          discount_amt: product.discount_amt,
          total_price: product.total_price,
          product_name: product.product_name || "",
        })),
        sub_total: formData.sub_total,
        discount: formData.discount,
        discount_total: (parseFloat(discountedSubtotal) + taxAmount).toFixed(2),
      };

      const response = await fetch(
        `${DOMAIN}/online_enquiry.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sanitizedFormData),
        }
      );

      const responseData = await response.json();
      if (responseData.status === 200) {
        setFormData(initialState);
        setGlobalTax({
          tax_type: "GST",
          tax_percentage: 0,
          tax_label: "GST@0%",
        });
        toast.success(responseData.msg, {
          position: "top-center",
          autoClose: 3000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/online/bills");
        }, 2000);
      } else {
        toast.error(responseData.msg, {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    }
  };

  const handleUpdateSubmit = async () => {
    try {
      setLoading(true);

      const subtotal = parseFloat(formData.sub_total) || 0;
      const discountValue = parseFloat(formData.discount) || 0;
      const discountAmount =
        discountType === "Discount %"
          ? ((subtotal * discountValue) / 100).toFixed(2)
          : discountValue.toFixed(2);
      const discountedSubtotal =
        discountType === "Discount %"
          ? (subtotal - (subtotal * discountValue) / 100).toFixed(2)
          : (subtotal - discountValue).toFixed(2);
      const taxRate = parseFloat(globalTax.tax_percentage) || 0;
      const taxAmount = (discountedSubtotal * taxRate) / 100;
      const total = (parseFloat(discountedSubtotal) + taxAmount).toFixed(2);

      const requestBody = {
        ...formData,
        discount_type: discountType,
        gst_type: globalTax.tax_label,
        gst_amount: taxAmount.toFixed(2),
        discount_amount: discountAmount,
        products: formData.products.map((product) => ({
          product_id: product.product_id,
          qty: product.qty,
          unit_id: product.unit_id,
          unit_name: product.unit_name,
          per_price: product.per_price,
          discount: product.discount,
          discount_amt: product.discount_amt,
          total_price: product.total_price,
          product_name: product.product_name || "",
        })),
        sub_total: formData.sub_total,
        discount: formData.discount,
        discount_total: total,
      };

      const response = await fetch(
        `${DOMAIN}/online_enquiry.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const responseData = await response.json();
      if (responseData.status === 200) {
        toast.success("Online Bill updated successfully!", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/console/online/bills");
        }, 2000);
      } else {
        toast.error(responseData.msg || "Failed to update bill", {
          position: "top-center",
          autoClose: 2000,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error("Error updating bill: " + error.message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAddRow = () => {
    setFormData((prevState) => ({
      ...prevState,
      products: [
        ...prevState.products,
        {
          product_id: "",
          product_name: "",
          qty: "",
          unit_id: "",
          unit_name: "",
          per_price: "",
          discount: "",
          discount_amt: "",
          total_price: "",
        },
      ],
    }));
  };

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      products: prevState.products.filter((_, i) => i !== index),
    }));
  };

  const calculateTotal = () => {
    const totalAmount = formData.products.reduce(
      (acc, row) => acc + (parseFloat(row.total_price) || 0),
      0
    );
    const discountValue = parseFloat(formData.discount) || 0;
    const discountAmount =
      discountType === "Discount %"
        ? ((totalAmount * discountValue) / 100).toFixed(2)
        : discountValue.toFixed(2);
    const discountedSubtotal =
      discountType === "Discount %"
        ? (totalAmount - (totalAmount * discountValue) / 100).toFixed(2)
        : (totalAmount - discountValue).toFixed(2);
    const taxRate = parseFloat(globalTax.tax_percentage) || 0;
    const taxAmount = (discountedSubtotal * taxRate) / 100;
    const finalTotal = (parseFloat(discountedSubtotal) + taxAmount).toFixed(2);

    setFormData((prevData) => ({
      ...prevData,
      sub_total: totalAmount.toFixed(2),
      discount_amount: discountAmount,
      discount_total: finalTotal,
    }));
  };

  const handleDiscountChange = (e) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      discount: value,
    }));
  };

  const handleKeyPress = (event, index) => {
    if (event.key === "Enter") {
      const lastRow = formData.products[formData.products.length - 1];
      if (
        lastRow.product_id &&
        lastRow.qty &&
        lastRow.unit_id &&
        lastRow.per_price &&
        lastRow.total_price
      ) {
        handleAddRow();
      } else {
        toast.error(
          "Please fill in all fields in the last row before adding a new row"
        );
      }
    }
  };

  const handleRemarkChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChange = (e, fieldName, rowIndex) => {
    const value = e.target ? e.target.value : e.value;
    let updatedFormData = { ...formData };

    if (rowIndex !== undefined) {
      updatedFormData = {
        ...formData,
        products: formData.products.map((row, index) =>
          index === rowIndex ? { ...row, [fieldName]: value } : row
        ),
      };
    } else {
      updatedFormData = {
        ...formData,
        [fieldName]: value,
      };
    }

    updatedFormData.products.forEach((row, index) => {
      const qty = parseFloat(row.qty) || 0;
      const price = parseFloat(row.per_price) || 0;
      const discountPercentage = parseFloat(row.discount) || 0;
      const discountInputAmount = parseFloat(row.discount_amt) || 0;

      let crtdiscountFiled = 0.0;
      let subtotal = qty * price;

      // if (fieldName === "per_price" || fieldName === "qty") {
      //   crtdiscountFiled = isNaN(discountPercentage)
      //     ? 0
      //     : (subtotal * discountPercentage) / 100;
      //   updatedFormData.products[index].discount_amt =
      //     crtdiscountFiled.toFixed(2);
      // }
      if (fieldName === "discount") {
        crtdiscountFiled = isNaN(discountPercentage)
          ? 0
          : (subtotal * discountPercentage) / 100;
        updatedFormData.products[index].discount_amt =
          crtdiscountFiled.toFixed(2);
      } else if (fieldName === "discount_amt") {
        crtdiscountFiled = discountInputAmount;
        const cal = (crtdiscountFiled / subtotal) * 100;
        updatedFormData.products[index].discount = isNaN(cal)
          ? 0
          : cal.toFixed(2);
      }

      let finalAmount = subtotal - crtdiscountFiled;
      updatedFormData.products[index].total_price = finalAmount.toFixed(2);
    });

    setFormData(updatedFormData);
  };

  useEffect(() => {
    calculateTotal();
  }, [formData.products, discountType, formData.discount, globalTax]);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const discountOptions = [
    { value: "Discount %", label: "Discount %" },
    { value: "Discount Amount", label: "Discount Amount" },
  ];

  return (
    <>
      <div className="main" style={{ cursor: "pointer" }}>
        <Container fluid className="px-0">
          <Row>
            <Col lg="12" className="py-3">
              <PageHead
                pagehead={<>Online Bills</>}
                onClick={() => navigate(-1)}
              />
            </Col>
            <Col lg="12" className="py-3">
              <Table>
                <tr>
                  <td>
                    <div className="party-on">
                      <Container>
                        <Row>
                          <Col lg="4" className="py-3">
                            <div className="d-flex">
                              <div className="w-250">
                                <TextInputForm
                                  placeholder={"Customer Name"}
                                  labelname={"Customer Name"}
                                  name="customer_name"
                                  value={formData.customer_name}
                                  onChange={(e) =>
                                    handleChange(e, "customer_name")
                                  }
                                />
                              </div>
                            </div>
                          </Col>
                          <Col lg="4" className="py-3">
                            <div className="W-50">
                              <TextInputForm
                                placeholder={"Mobile Number"}
                                labelname={"Mobile Number"}
                                name="phone"
                                value={formData.phone}
                                onChange={(e) => handleChange(e, "phone")}
                              />
                            </div>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="4" className="py-3">
                            <label className="pb-2">Address</label>
                            <textarea
                              className="form-cntrl form-control"
                              placeholder={"Address"}
                              name="address"
                              value={formData.address}
                              onChange={(e) => handleChange(e, "address")}
                            />
                          </Col>
                          <Col lg="4" className="py-3">
                            <div className="W-50">
                              <TextInputForm
                                placeholder={"Tax Invoice No"}
                                labelname={"Tax Invoice No"}
                                name="tax_invoice_no"
                                value={formData.tax_invoice_no}
                                onChange={(e) =>
                                  handleChange(e, "tax_invoice_no")
                                }
                              />
                            </div>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                  </td>
                  <td className="mx-auto float-end">
                    <div>
                      <Calender
                        setLabel={(date) => setLabel(date, "bill_date")}
                        selectedDate={
                          formData.bill_date &&
                          moment(formData.bill_date).isValid()
                            ? moment(formData.bill_date).toDate()
                            : new Date()
                        }
                        calenderlabel="Bill Date"
                      />
                    </div>
                  </td>
                </tr>
              </Table>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="main my-3">
        <Container fluid className="px-0">
          <Row>
            <Col lg="12" className="py-3">
              <div>
                No Of Products: <span>{formData.products.length}</span>
              </div>
            </Col>
            <Col lg="12" md="6" xs="12">
              <div className="py-2 category-table bill">
                <Table>
                  <thead>
                    <tr>
                      <th className="wrdbrk w-10">#</th>
                      <th className="wrdbrk w-20">Product Name</th>
                      <th className="wrdbrk w-7">Qty</th>
                      <th className="wrdbrk w-10">Unit</th>
                      <th className="wrdbrk w-7">Price / Unit</th>

                      <th className="wrdbrk w-10">Amount</th>
                      <th className="wrdbrk w-10"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.products &&
                      formData.products.map((row, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>
                            <DropDownUI
                              optionlist={productData.map((user) => ({
                                value: user.product_id,
                                label: user.product_name,
                              }))}
                              placeholder="Product Name"
                              name="product_id"
                              value={row.product_id}
                              onChange={(updatedFormData) => {
                                const selectedProduct = productData.find(
                                  (p) =>
                                    p.product_id === updatedFormData.product_id
                                );
                                const unitRate =
                                  Number(selectedProduct?.price) || 0;
                                const discountPct =
                                  Number(selectedProduct?.discount) || 0;
                                const qty =
                                  Number(formData.products[index]?.qty) || 0;
                                const hasDiscount =
                                  Number.isFinite(discountPct) &&
                                  discountPct > 0;
                                const discountAmt = hasDiscount
                                  ? (unitRate * discountPct) / 100
                                  : 0;
                                const perPrice = Math.max(
                                  unitRate - discountAmt,
                                  0
                                );
                                const totalPrice = (qty * perPrice).toFixed(2);

                                setFormData((prev) => ({
                                  ...prev,
                                  products: prev.products.map((p, i) =>
                                    i === index
                                      ? {
                                          ...p,
                                          product_id:
                                            updatedFormData.product_id,
                                          product_name: selectedProduct
                                            ? selectedProduct.product_name
                                            : "",
                                          per_price: perPrice.toFixed(2),
                                          unit_id: selectedProduct
                                            ? selectedProduct.unit_id
                                            : "",
                                          unit_name: selectedProduct
                                            ? selectedProduct.unit_name
                                            : "",
                                          discount: discountPct.toFixed(2),
                                          discount_amt: (
                                            qty * discountAmt
                                          ).toFixed(2),
                                          total_price: totalPrice,
                                        }
                                      : p
                                  ),
                                }));
                              }}
                              onKeyDown={(e) => handleKeyPress(e, index)}
                              autoFocus={index === formData.products.length - 1}
                            />
                          </td>
                          <td>
                            <TextInputForm
                              placeholder={"Qty"}
                              name="qty"
                              value={row.qty}
                              onChange={(e) => handleChange(e, "qty", index)}
                              onKeyDown={(e) => handleKeyPress(e, index)}
                            />
                          </td>
                          <td>
                            <DropDownUI
                              optionlist={UnitData.map((user) => ({
                                value: user.unit_id,
                                label: user.unit_name,
                              }))}
                              placeholder="Unit"
                              name="unit_id"
                              value={row.unit_id}
                              onChange={(updatedFormData) => {
                                const selectedUnit = UnitData.find(
                                  (u) => u.unit_id === updatedFormData.unit_id
                                );
                                setFormData({
                                  ...formData,
                                  products: formData.products.map((r, i) =>
                                    i === index
                                      ? {
                                          ...r,
                                          unit_id: updatedFormData.unit_id,
                                          unit_name: selectedUnit
                                            ? selectedUnit.unit_name
                                            : "",
                                        }
                                      : r
                                  ),
                                });
                              }}
                              onKeyDown={(e) => handleKeyPress(e, index)}
                            />
                          </td>
                          <td>
                            <TextInputForm
                              placeholder={"Price"}
                              name="per_price"
                              value={row.per_price}
                              onChange={(e) =>
                                handleChange(e, "per_price", index)
                              }
                              onKeyDown={(e) => handleKeyPress(e, index)}
                            />
                          </td>
                          <td>
                            <TextInputForm
                              placeholder={"Total Amount"}
                              name="total_price"
                              value={row.total_price}
                              onChange={(e) =>
                                handleChange(e, "total_price", index)
                              }
                              onKeyDown={(e) => handleKeyPress(e, index)}
                            />
                          </td>
                          <td>
                            <Delete
                              onClick={() => handleDeleteRow(index)}
                              label={<MdDeleteForever />}
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="my-3">
          <Container>
            <Row>
              <Col lg="5"></Col>
              <Col lg="7">
                <div className="inside my-3">
                  <Table>
                    <tr>
                      <td>Sub Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Sub Total"}
                          name="sub_total"
                          value={formData.sub_total}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount</td>
                      <td>
                        <DropDownUI
                          optionlist={discountOptions}
                          placeholder="Discount Type"
                          name="discount_type"
                          value={discountType}
                          onChange={(updatedValue) => {
                            setDiscountType(updatedValue.discount_type);
                            setFormData((prevData) => ({
                              ...prevData,
                              discount_type: updatedValue.discount_type,
                            }));
                            calculateTotal();
                          }}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={
                            discountType === "Discount %"
                              ? "Discount %"
                              : "Discount Amount"
                          }
                          name="discount"
                          value={formData.discount}
                          onChange={handleDiscountChange}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Discount Amount</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Discount Amount"}
                          name="discount_amount"
                          value={formData.discount_amount}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>GST</td>
                      <td>
                        <DropDownUI
                          optionlist={alltax}
                          placeholder="GST"
                          name="tax_label"
                          value={globalTax.tax_label}
                          onChange={(updatedFormData) => {
                            const selectedTax = alltax.find(
                              (tax) => tax.value === updatedFormData.tax_label
                            );
                            const taxType = selectedTax
                              ? selectedTax.value.split("@")[0]
                              : "GST";
                            const taxPercentage = selectedTax
                              ? parseFloat(
                                  selectedTax.value.match(/\d+\.*\d*/)[0]
                                )
                              : 0;
                            setGlobalTax({
                              tax_type: taxType,
                              tax_percentage: taxPercentage,
                              tax_label: updatedFormData.tax_label,
                            });
                          }}
                        />
                      </td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"GST Amount"}
                          name="gst_amount"
                          value={(
                            (((parseFloat(formData.sub_total) || 0) -
                              (discountType === "Discount %"
                                ? ((parseFloat(formData.sub_total) || 0) *
                                    (parseFloat(formData.discount) || 0)) /
                                  100
                                : parseFloat(formData.discount) || 0)) *
                              (parseFloat(globalTax.tax_percentage) || 0)) /
                            100
                          ).toFixed(2)}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder={"Total"}
                          name="discount_total"
                          value={formData.discount_total}
                          readOnly
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Remark</td>
                      <td></td>
                      <td className="w-25">
                        <TextInputForm
                          placeholder="Remarks"
                          name="remark"
                          value={formData.remark}
                          onChange={handleRemarkChange}
                        />
                      </td>
                    </tr>
                  </Table>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
      <div className="main stick-bottom">
        <div className="w-50 ms-auto">
          <Container>
            <Row>
              <Col lg="12">
                <div className="text-center">
                  {type === "edit" ? (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/online/bills")}
                        />
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                        />
                      </span>
                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => navigate("/console/online/bills")}
                        />
                      </span>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
};

export default OnlineBillEntry;

